module.exports = __webpack_public_path__ + "media/lobby_normal4.91a36d57.mp3";